import member1 from "../assets/members/member1.jpg";
import member2 from "../assets/members/member2.jpeg";
import member3 from "../assets/members/member3.png";
import member4 from "../assets/members/member4.jpeg";
import member5 from "../assets/members/member5.jpg";
import member6 from "../assets/members/member6.png";
import member7 from "../assets/members/member7.jpg";
import member8 from "../assets/members/member8.png";
import member9 from "../assets/members/member9.png";
import member10 from "../assets/members/member10.png";
import member11 from "../assets/members/member11.png";
import member12 from "../assets/members/member12.png";
import member13 from "../assets/members/member13.jpg";
import member14 from "../assets/members/member14.jpg";
import member15 from "../assets/members/member15.png";
import member16 from "../assets/members/member16.png";
import member17 from "../assets/members/member17.png";
import member18 from "../assets/members/member18.png";
import member19 from "../assets/members/member19.png";
import member20 from "../assets/members/member20.png";

export const memberList = [
    {
        img: member1,
        alt: 'Member 1',
    },
    {
        img: member2,
        alt: 'Member 2',
    },
    {
        img: member3,
        alt: 'Member 3',
    },
    {
        img: member4,
        alt: 'Member 4',
    },
    {
        img: member5,
        alt: 'Member 5',
    },
    {
        img: member6,
        alt: 'Member 6',
    },
    {
        img: member7,
        alt: 'Member 7',
    },
    {
        img: member8,
        alt: 'Member 8',
    },
    {
        img: member9,
        alt: 'Member 9',
    },
    {
        img: member10,
        alt: 'Member 10',
    },
    {
        img: member11,
        alt: 'Member 11',
    },
    {
        img: member12,
        alt: 'Member 12',
    },
    {
        img: member13,
        alt: 'Member 13',
    },
    {
        img: member14,
        alt: 'Member 14',
    },
    {
        img: member15,
        alt: 'Member 15',
    },
    {
        img: member16,
        alt: 'Member 16',
    },
    {
        img: member17,
        alt: 'Member 17',
    },
    {
        img: member18,
        alt: 'Member 18',
    },
    {
        img: member19,
        alt: 'Member 19',
    },
    {
        img: member20,
        alt: 'Member 20',
    }
];
